import * as React from 'react';
import { createSvg } from './utils/createSvg';
export var FlagJp = createSvg(React.createElement(React.Fragment, null,
    React.createElement("clipPath", { id: "FlagJp-a" },
        React.createElement("path", { d: "M177.17 0h708.66v708.66H177.17z" })),
    React.createElement("g", { clipPath: "url(#FlagJp-a)", fillRule: "evenodd", strokeWidth: "1pt", transform: "translate(-128) scale(.72249)" },
        React.createElement("path", { d: "M0 0h1063v708.66H0z", fill: "#fff" }),
        React.createElement("circle", { cx: "523.08", cy: "344.05", fill: "#d30000", transform: "translate(-59.707 -34.521) scale(1.1302)", r: "194.93" }))), '0 0 512 512', 'FlagJp');
//# sourceMappingURL=FlagJp.js.map